import * as actions from '../../../redux/actionTypes';
import { get, post, put, put_listing } from '../../../api/commonAPI'
export const putToMyFavourites = ({data})=> {
  return (dispatch, getState, {axiosInstance}) => {
    dispatch({
        type: actions.TOGGLE_MY_FAVOURITES,
        payload: data

      });
      axiosInstance.put(`space/3`, data)
        .then(res => {
          dispatch({
            type: actions.TOGGLE_MY_FAVOURITES_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: actions.TOGGLE_MY_FAVOURITES_FAILS,
            payload: error
          });
        });
    };
  };

  // method for handle the meta data request (bank details per market)
  export const fetchMetaData = ({ country } = {}) => {
    return (dispatch, getState, {axiosInstance}) => {
    const market = String(country || getState()?.locationMeta?.data?.country_shortCode || 'LK').toUpperCase();
   get(`md/meta-data/${market}`)
      .then(res => {
        dispatch({
          type: actions.FETCH_META_DATA_SUCCESS,
          payload: res.data
        }); 
        localStorage.setItem('metaData', JSON.stringify(res.data));
        localStorage.setItem('metaDataCountry', market);
      })
      .catch(error => {
        dispatch({
          type: actions.FETCH_META_DATA_FAILS,
          payload: error
        });
      });
    }
  }